(function($) {
    $(document).ready(function() {
        var isDragging = false;
        
        // Check for leader parameter on page load
        var urlParams = new URLSearchParams(window.location.search);
        var leaderSlug = urlParams.get('leader');
        if (leaderSlug) {
            var leaderId = $('.leader-item[data-leader-slug="' + leaderSlug + '"]').data('leader-id');
            if (leaderId) {
                loadLeaderModal(leaderId);
            }
        }
        
        // Track drag state
        $('.leadership-carousel').on('beforeChange', function() {
            isDragging = true;
        });
        
        $('.leadership-carousel').on('swipe', function() {
            isDragging = true;
        });
        
        $('.leadership-carousel').on('drag', function() {
            isDragging = true;
        });
        
        $('.leadership-carousel').on('afterChange', function() {
            setTimeout(function() {
                isDragging = false;
            }, 100);
        });
        
        $('.leadership-carousel').on('swipeEnd', function() {
            setTimeout(function() {
                isDragging = false;
            }, 100);
        });
        
        $('.leadership-carousel').on('dragEnd', function() {
            setTimeout(function() {
                isDragging = false;
            }, 100);
        });
        
        // Remove Bootstrap modal attributes to prevent automatic modal opening
        $('.leader-item').removeAttr('data-bs-toggle').removeAttr('data-bs-target');
        
        $('.leader-item').on('click', function() {
            if (isDragging) return;
            
            var leaderId = $(this).data('leader-id');
            var leaderSlug = $(this).data('leader-slug');
            
            // Update URL with leader parameter
            var url = new URL(window.location);
            url.searchParams.set('leader', leaderSlug);
            window.history.pushState({}, '', url);
            
            loadLeaderModal(leaderId);
        });
        
        // Remove leader parameter when modal is closed
        $('#leaderModal').on('hidden.bs.modal', function() {
            var url = new URL(window.location);
            url.searchParams.delete('leader');
            window.history.pushState({}, '', url);
        });
        
        function loadLeaderModal(leaderId) {
            $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'get_leader_details',
                    leader_id: leaderId
                },
                success: function(response) {
                    var data = JSON.parse(response);
                    
                    // Build contact info
                    var contactInfo = [];
                    var themeUrl = ajax_object.theme_url || '/wp-content/themes/hubbard-radio-corporate';
                    if (data.phone) {
                        contactInfo.push('<div class="leadership-contact-item"><img src="' + themeUrl + '/images/phone.png" width="24" alt="Phone"><span><a href="tel:' + data.phone + '">' + data.phone_formatted + '</a></span></div>');
                    }
                    if (data.email) contactInfo.push('<div class="leadership-contact-item"><img src="' + themeUrl + '/images/email.png" width="24" alt="Email"><span><a href="mailto:' + data.email + '">' + data.email + '</a></span></div>');
                    if (data.linkedin_url) contactInfo.push('<div class="leadership-contact-item"><img src="' + themeUrl + '/images/linkedin.png" width="24" alt="LinkedIn"><span><a href="' + data.linkedin_url + '" target="_blank">' + data.linkedin_url.replace(/^https?:\/\//, '') + '</a></span></div>');
                    var contactHtml = contactInfo.length > 0 ? '<div class="contact-info">' + contactInfo.join('') + '</div>' : '';
                    
                    // Set title with image, name, position, and contact info
                    $('.leader-modal-title').html('<img src="' + data.image + '" class="leader-modal-image" alt="' + data.name + '"><h1 class="leader-name">' + data.name + '</h1><p class="leader-title">' + data.position + '</p>' + contactHtml);
                    
                    // Set content without contact info
                    $('.leader-modal-content').html(data.content);
                    
                    $('#leaderModal').modal('show');
                }
            });
        }
    });
})(jQuery);